  import React from 'react';
  import { X } from 'lucide-react';

  // Create this CSS file 4218

  const InstanceMessageTemplateDocument = ({ onClose, onUse, onCancel }) => {
    const templateContent = `Hi {{client_name}},

  Just following up on the pending documents for {{task_name}}. Could you please share them at your earliest convenience?

  If you need any assistance or have questions, feel free to reach out.

  Best,
  {{your_name}}`;

    const handleUseTemplate = () => {
      if (onUse) {
        onUse(templateContent);
      }
    };

    const handleCancel = () => {
      if (onCancel) {
        onCancel();
      }
    };

    return (
      <div className="instance-message-template-document">
        {/* Header */}
        <div className="instance-message-template-header">
          <div className="instance-message-template-title-wrapper">
            <h3 className="instance-message-template-title">Document Follow-up</h3>
            <p className="instance-message-template-category">Follow-ups • Documents</p>
          </div>
          
          {/* Close Button */}
          <button 
            className="instance-message-template-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <X className="instance-message-template-close-icon" />
          </button>
        </div>

        {/* Template Content Preview */}
        <div className="instance-message-template-preview">
          <pre className="instance-message-template-content">
            {templateContent}
          </pre>
        </div>

        {/* Action Buttons */}
        <div className="instance-message-template-actions">
          <button 
            className="instance-message-template-use-btn"
            onClick={handleUseTemplate}
          >
            Use Template
          </button>
          
          <button 
            className="instance-message-template-cancel-btn"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  };

  export default InstanceMessageTemplateDocument;